import { isArray, isDefined, isString } from './isDefined';

export const ICC_CHANGE_IN_PROGRESS_MESSAGE = 'Change icc in progress';

const hasIccChangeInProgressProblem = problems => {
  if (!isArray(problems)) {
    return false;
  }

  return problems.some(
    problem =>
      isString(problem?.message) &&
      problem.message.includes(ICC_CHANGE_IN_PROGRESS_MESSAGE)
  );
};

const checkShouldShowQRCode = ({
  subscription,
  hasClientAccounts,
  isESimCard,
  activationCode
}) => {
  return Boolean(
    isDefined(subscription) &&
      hasClientAccounts &&
      isESimCard &&
      isDefined(activationCode) &&
      !hasIccChangeInProgressProblem(subscription?.problems)
  );
};

export default checkShouldShowQRCode;
